import type { ComponentType } from 'react';
import FooterStandard from '../Footer';
import FooterInstitucional from './FooterInstitucional';
import type { FooterProps } from '../types';
import {
  FOOTER_TEMPLATE_INSTITUCIONAL,
  FOOTER_TEMPLATE_STANDARD,
  normalizeFooterTemplateCode,
} from '../../templateCodes';

export interface FooterRegistryEntry {
  code: string;
  Component: ComponentType<FooterProps>;
}

export const footerRegistry: FooterRegistryEntry[] = [
  { code: FOOTER_TEMPLATE_STANDARD, Component: FooterStandard },
  { code: FOOTER_TEMPLATE_INSTITUCIONAL, Component: FooterInstitucional },
];

export function getFooterTemplate(code?: string | null): FooterRegistryEntry {
  const normalized = normalizeFooterTemplateCode(code);
  return (
    footerRegistry.find((entry) => entry.code === normalized) ??
    footerRegistry.find((entry) => entry.code === FOOTER_TEMPLATE_STANDARD)!
  );
}
